import {
  ParticipationStatus,
  useGroupedParticipationsItemsCount,
  usePriceGroupByCountries,
} from '@app/api';
import { NO_PRICE_GROUP } from 'lib/priceComputation';
import { useMemo } from 'react';

export const useCountByCountryGroup = (sessionId?: string) => {
  const { data: groupedCount } = useGroupedParticipationsItemsCount(sessionId);

  const priceGroups = usePriceGroupByCountries();

  return useMemo(() => {
    const res = {} as any;
    if (!groupedCount?.countryKey || !priceGroups) {
      return res;
    }
    for (const key in groupedCount.countryKey) {
      let group = priceGroups[key as any];
      if (!group) {
        group = NO_PRICE_GROUP;
      }
      if (!res[group]) {
        res[group] = 0;
      }
      const byStatus = groupedCount.countryKey[key];
      res[group] +=
        (byStatus[ParticipationStatus.PROCESSING_PAYMENT] || 0) +
        (byStatus[ParticipationStatus.PAYED] || 0) +
        (byStatus[ParticipationStatus.PARTICIPATED] || 0) +
        (byStatus[ParticipationStatus.BOOKED] || 0);
    }
    return res;
  }, [groupedCount, priceGroups]);
};
